import { gql } from '@apollo/client';

export const GET_PRODUCT_CATEGORIES = gql`
  query productCategories(
    $filter: ProductCategoryFilter!
    $where: ProductCategoriesWhereFilter
  ) {
    productCategories(filter: $filter, where: $where) {
      count
      data {
        id
        title
        productCategoryCode
        description
        isActive
      }
    }
  }
`;

export const GET_PRODUCT_CATEGORY = gql`
  query productCategory($id: ID!) {
    productCategory(where: { id: $id }) {
      id
      title
      productCategoryCode
      refData
      description
      isActive
      tenantId
    }
  }
`;

export const PRODUCT_CATEGORY_FILTER = gql`
  query productCategoryFilters($filter: ProductCategoryFilter!) {
    productCategoryFilters(filter: $filter) {
      count
      data {
        title
        productCategoryCode
        refData
        description
        isActive
        tenantId
      }
    }
  }
`;
